module.exports = __webpack_public_path__ + "static/media/vid4.703b526c.mp4";